export default __webpack_public_path__ + "landlord-3-364833c3972711786409c05fc93ff3db.bundle.svg";